import { FC } from 'react';
import SidebarAwareToastContainer from 'src/use-cases/toast/SidebarAwareToastContainer';

import 'react-toastify/dist/ReactToastify.css';

const Notification: FC = () => (
  <SidebarAwareToastContainer
    style={{ width: 'fit-content', minWidth: '250px' }}
    toastClassName='bg-black flex items-center min-h-10 py-0 rounded-md overflow-hidden cursor-pointer px-15'
    bodyClassName='flex items-center text-white p-3 '
    limit={2}
  />
);
export default Notification;
